import React from 'react';
import GarmentCard from './GarmentCard';

const GarmentGrid = ({ garments, onEdit, onDelete }) => {
  if (garments.length === 0) {
    return (
      <div className="text-center py-24 border-y border-neutral-200">
        <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-neutral-500 mb-3">
          Vacío
        </p>
        <h3 className="text-2xl font-black uppercase tracking-tight text-black mb-2">
          No se encontraron prendas
        </h3>
        <p className="text-sm text-neutral-500 max-w-md mx-auto">
          Intenta ajustar los filtros o vuelve más tarde para descubrir nuevas piezas.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-3 gap-y-10">
      {garments.map((garment) => (
        <GarmentCard
          key={garment.id}
          garment={garment}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default GarmentGrid;
